<template>
  <div class="pa-3">
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>
    <div>
      <v-layout row wrap>
        <v-flex xs6>
          <v-card class="pa-2 mr-1">
            <div class="primary--text" style="font-weight: bold">Average Check-in time</div>
            <div>{{ avgcheckin }}</div>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card class="pa-2 ml-1">
            <div class="primary--text" style="font-weight: bold">Average Check-out time</div>
            <div>{{ avgcheckout }}</div>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    <div class="primary--text mb-2" style="font-size: 18px; font-weight: 600">
      Check-in & Check-out performance
    </div>
    <DateFilter
      @changeDate="com7checkIncheckOutStatByAdminId"
      :defaultFilter="'last_month'"
      v-model="selectedDate"
    ></DateFilter>
    <div class="mt-3">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="data"
        class="elevation-1"
        v-bind:pagination.sync="pagination"
        hide-actions
      >
        <template v-slot:items="props">
          <tr>
            <td>
              {{ props.item.date }}
            </td>
            <td>
              <template v-if="props.item.checkin.length > 0">
                <div v-for="(val, index) in props.item.checkin" :key="index">
                  <span>
                    {{ val }}
                  </span>
                </div>
              </template>
              <template v-else>-</template>
            </td>
            <td>
              <template v-if="props.item.checkout.length > 0">
                <div v-for="(val, index) in props.item.checkout" :key="index">
                  <span>
                    {{ val }}
                  </span>
                </div>
              </template>
              <template v-else>-</template>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import moment from 'moment'

export default {
  props: ['dialogdata'],
  computed: {
    ...mapGetters(['selectedBot'])
  },
  components: {
    DateFilter
  },
  data() {
    return {
      avgcheckin: '-',
      avgcheckout: '-',
      data: [],
      pagination: { rowsPerPage: -1, sortBy: '' },
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Check-in time', value: 'checkin' },
        { text: 'Check-out time', value: 'checkout' }
      ],
      loading: false,
      selectedDate: {
        start: moment().subtract(1, 'months').format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      }
    }
  },
  mounted() {
    this.com7checkIncheckOutStatByAdminId()
  },
  methods: {
    getAverageTime(times) {
      var count = times.length
      var timesInSeconds = []
      // loop through times
      for (var i = 0; i < count; i++) {
        // parse
        var pieces = times[i].split(':')
        var ampm = pieces[2].split(' ')
        var hrs = Number(pieces[0])
        var mins = Number(pieces[1])
        var secs = Number(ampm[0])
        var ampm = ampm[1]
        // convert to 24 hr format (military time)
        if (ampm == 'PM') hrs = hrs + 12
        // find value in seconds of time
        var totalSecs = hrs * 60 * 60
        totalSecs += mins * 60
        totalSecs += secs
        // add to array
        timesInSeconds[i] = totalSecs
      }
      // find average timesInSeconds
      var total = 0

      for (var j = 0; j < count; j++) {
        total = total + Number(timesInSeconds[j])
      }
      var avg = Math.round(total / count)
      // console.log('avg secs: ' + avg)
      // turn seconds back into a time
      var avgMins = Math.floor(avg / 60)
      var avgSecs = avg - 60 * avgMins
      var avgHrs = Math.floor(avgMins / 60)
      // console.log('hours: ' + avgHrs)
      avgMins = avgMins - 60 * avgHrs
      // convert back to 12 hr. format
      var avgAmpm = 'AM'
      if (avgHrs > 12) {
        avgAmpm = 'PM'
        avgHrs = avgHrs - 12
      }
      // add leading zeros for seconds, minutes
      avgSecs = ('0' + avgSecs).slice(-2)
      avgMins = ('0' + avgMins).slice(-2)
      // your answer
      return avgHrs + ':' + avgMins + ':' + avgSecs + ' ' + avgAmpm
    },
    com7checkIncheckOutStatByAdminId(adminid) {
      var data = {
        pageid: this.selectedBot.pageid,
        adminId: this.dialogdata,
        startTime: this.selectedDate.start, // YYYY-MM-DD
        endTime: this.selectedDate.end // YYYY-MM-DD
      }
      this.loading = true
      api.com7checkIncheckOutStatByAdminId(data, (err, response) => {
        this.loading = false
        if (response.data && response.data.length) {
          this.data = []
          for (const key in response.data[0]) {
            var obj = {
              date: key,
              checkin: response.data[0][key].checkIn,
              checkout: response.data[0][key].checkOut
            }
            this.data.push(obj)
          }
          var checkintimes = this.data.map((el) => {
            if (el.checkin) {
              return moment(el.checkin, 'h:mm:ss A').format('h:mm:ss A')
            } else return null
          })
          var checkouttimes = this.data.map((el) => {
            if (el.checkout) {
              return moment(el.checkout, 'h:mm:ss A').format('h:mm:ss A')
            } else return null
          })
          this.avgcheckin = this.getAverageTime(checkintimes.filter((el) => el))
          this.avgcheckin = moment(this.avgcheckin, 'h:mm:ss A').format('HH:mm')
          this.avgcheckout = this.getAverageTime(checkouttimes.filter((el) => el))
          this.avgcheckout = moment(this.avgcheckout, 'h:mm:ss A').format('HH:mm')
        } else {
          this.data = []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/agentmanagement/DialogAgent.vue